import { btsItems } from "@/lib/data";

export default function BTSSection() {
  return (
    <section
      id="bts"
      data-testid="section-bts"
      className="relative bg-[#0A0A0A] py-24 md:py-36 px-6 md:px-12 lg:px-24 border-y border-white/5"
    >
      {/* Section header — flipped/raw */}
      <div className="mx-auto max-w-[1600px]">
        <div className="grid grid-cols-12 gap-8 items-end mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-3 md:order-3 md:text-right">
            <p className="font-accent text-[10px] text-[#D4AF37]">Part 02</p>
          </div>
          <div className="col-span-12 md:col-span-7 md:order-2">
            <p className="font-accent text-[10px] text-zinc-500 mb-3">
              Unedited · 35mm scans &amp; on-set polaroids
            </p>
            <h2 className="font-serif-display text-5xl md:text-7xl tracking-tighter text-white leading-[1] italic">
              Behind the Scenes.
            </h2>
            <p className="mt-6 text-zinc-500 max-w-md font-light">
              Crew calls at 5am. Sandbags, gaff tape, and a half-cup of coffee.
              The unglamorous middle that makes the polished frames possible.
            </p>
          </div>
          <div className="col-span-12 md:col-span-2 md:order-1">
            <p className="font-accent text-[10px] text-zinc-600">
              {btsItems.length.toString().padStart(2, "0")} Stills
            </p>
          </div>
        </div>

        {/* Asymmetric masonry */}
        <div className="bts-masonry columns-1 sm:columns-2 lg:columns-3 gap-4 md:gap-6 space-y-4 md:space-y-6">
          {btsItems.map((b, i) => (
            <figure
              key={b.id}
              data-testid={`bts-item-${b.id}`}
              className={`group relative overflow-hidden bg-black mb-4 md:mb-6 ${
                i % 5 === 0 ? "rotate-[-0.4deg]" : i % 4 === 0 ? "rotate-[0.5deg]" : ""
              }`}
            >
              <div className={`${b.aspect} relative overflow-hidden`}>
                <img
                  src={b.src}
                  alt={b.caption}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-[900ms] ease-out group-hover:scale-[1.03]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-80 group-hover:opacity-50 transition-opacity duration-700" />
              </div>

              <figcaption className="absolute bottom-0 left-0 right-0 p-4 md:p-5 flex items-center justify-between">
                <span className="font-accent text-[9px] text-white/70">
                  {String(i + 1).padStart(3, "0")}
                </span>
                <span className="font-accent text-[9px] text-white/80 text-right max-w-[70%]">
                  {b.caption}
                </span>
              </figcaption>
            </figure>
          ))}
        </div>

        {/* Footnote */}
        <div className="mt-16 md:mt-24 flex items-center gap-6">
          <span className="h-px w-12 bg-zinc-700" />
          <p className="font-accent text-[10px] text-zinc-500">
            All images shot on personal cameras &mdash; not for client delivery.
          </p>
        </div>
      </div>
    </section>
  );
}
